/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop, RadialGradient } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstArtLessonBookingUnlockedSvg({ size, accessibilityLabel, testID }: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M84.5601 76.664C84.5601 76.664 53.1652 89.087 50.3505 89.087C47.5358 89.087 16.0683 76.7899 16.0683 76.7899C14.6937 76.7919 14.6202 23.9074 15.9958 23.9054C15.9958 23.9054 48.425 10 50.3515 10C52.278 10 84.4886 23.7795 84.4886 23.7795C85.12 23.7795 85.1925 76.663 84.5611 76.664H84.5601Z"
          fill="url(#paint0_linear_8631_21039)"
        />
        <Path
          d="M50.3516 89.088C53.1663 89.088 84.5612 76.665 84.5612 76.665C85.1926 76.665 85.1201 23.7795 84.4887 23.7805C84.4887 23.7805 52.2781 10.001 50.3516 10.001V89.089V89.088Z"
          fill="url(#paint1_linear_8631_21039)"
        />
        <Path
          d="M83.2631 25.2783C83.2631 25.2783 52.2076 11.8996 50.3506 11.8996C48.4936 11.8996 17.2265 25.4002 17.2265 25.4002C15.9002 25.4022 15.9707 76.7459 17.297 76.7438C17.297 76.7438 47.6365 88.6825 50.3506 88.6825C53.0646 88.6825 83.3336 76.621 83.3336 76.621C83.9419 76.621 83.8724 25.2763 83.2631 25.2773V25.2783ZM80.5733 74.4609C80.5733 74.4609 52.841 85.5113 50.3546 85.5113C47.8682 85.5113 20.0715 74.5726 20.0715 74.5726C18.857 74.5747 18.7925 27.5331 20.007 27.5321C20.007 27.5321 48.6537 15.1635 50.3546 15.1635C52.0555 15.1635 80.5088 27.4203 80.5088 27.4203C81.0667 27.4203 81.1312 74.4609 80.5733 74.4609Z"
          fill="#BCB6C3"
        />
        <Path
          d="M84.4879 23.7795C84.4879 23.7795 52.2773 9.99999 50.3518 9.99999C48.4263 9.99999 15.9962 23.9054 15.9962 23.9054C14.6215 23.9074 14.694 76.7919 16.0687 76.7898C16.0687 76.7898 47.5361 89.087 50.3508 89.087C53.1655 89.087 84.5604 76.664 84.5604 76.664C85.1919 76.664 85.1194 23.7785 84.4879 23.7795ZM81.6974 74.4384C81.6974 74.4384 52.9339 85.8211 50.3548 85.8211C47.7758 85.8211 18.9458 74.5542 18.9458 74.5542C17.686 74.5562 17.6195 26.1038 18.8794 26.1018C18.8794 26.1018 48.5905 13.3615 50.3548 13.3615C52.1192 13.3615 81.6309 25.986 81.6309 25.986C82.209 25.986 82.2765 74.4374 81.6974 74.4384Z"
          fill="url(#paint2_linear_8631_21039)"
        />
        <Path
          d="M24.0935 30.6778V71.2964C24.0935 71.3195 24.1076 71.3407 24.1277 71.3497L42.5901 79.4283C42.7754 79.5099 42.9385 79.2763 42.7975 79.1302L30.4269 66.2691C30.4188 66.2611 30.4138 66.25 30.4118 66.2389L24.2093 30.6678C24.1972 30.5983 24.0945 30.6063 24.0945 30.6778H24.0935Z"
          fill="#E3DEED"
        />
        <Path
          d="M75.3808 30.6778V71.2964C75.3808 71.3195 75.3667 71.3407 75.3466 71.3497L56.8842 79.4283C56.699 79.5099 56.5358 79.2763 56.6768 79.1302L69.0475 66.2691C69.0555 66.2611 69.0605 66.25 69.0626 66.2389L75.265 30.6678C75.2771 30.5983 75.3798 30.6063 75.3798 30.6778H75.3808Z"
          fill="#EFEEF0"
        />
        <Path
          d="M37.3947 84.5868L35.7876 84.2156C35.3351 85.0737 34.8874 85.9438 34.4727 86.8138C37.3711 86.6622 36.2542 86.5624 37.3947 84.5868Z"
          fill="#7F8AA5"
        />
        <Path
          d="M90.4344 68.379C89.9678 67.5249 87.2437 67.8482 86.1974 67.8203V28.5879V27.5982C81.3996 27.8416 75.5178 27.4545 70.5598 27.4744C68.4672 27.4824 66.3699 27.4664 64.2726 27.4744C53.9371 27.5024 43.0595 27.7299 32.3469 27.7219C43.0548 27.7299 53.9371 27.5024 64.2679 27.4744C66.3605 27.4704 68.4625 27.4824 70.555 27.4744C75.5131 27.4545 81.3949 27.8416 86.1927 27.5982C86.2068 27.5982 86.1456 27.3587 86.2634 27.3507C88.3701 27.227 91.0188 27.8097 90.4297 25.1237C90.4297 25.1237 90.4202 25.1277 90.4155 25.1317C90.2506 24.537 89.6285 24.094 88.8744 24.094H53.1642C53.1312 23.6949 53.0416 23.18 52.9379 23.1441C52.641 23.0403 46.7686 22.9885 46.5094 23.1441C46.4387 23.184 46.4104 23.6709 46.4199 24.094H10.6766C9.77646 24.094 9.04595 24.7126 9.04595 25.4749V26.2132H9.21091C9.71048 27.6181 11.6617 27.2709 13.4102 27.3507V28.8354C33.1858 28.8633 52.9709 28.8314 72.7466 28.7117C76.1588 28.6917 79.5663 28.7117 82.9785 28.7117C79.571 28.7117 76.1635 28.6917 72.7466 28.7117C52.9709 28.8274 33.1858 28.8633 13.4102 28.8354C13.429 40.8525 13.4102 66.9023 13.4102 66.9542C13.429 67.1578 13.3348 67.8562 13.4809 67.944L40.0055 68.0677C52.9144 68.0278 65.8326 67.8482 78.7368 67.8203C80.4853 67.8203 82.2479 67.7923 84.0012 67.8003C82.2479 67.7923 80.4853 67.8163 78.7368 67.8203C65.8326 67.8482 52.9144 68.0278 40.0102 68.0677C29.8066 68.0996 19.5983 68.0438 9.39 68.0677C8.79616 68.2633 9.01767 69.3568 9.16849 69.7998C20.0696 69.6123 30.9943 69.6123 41.9048 69.5524C30.9896 69.6163 20.0696 69.6123 9.16849 69.7998C9.36643 70.3746 9.50311 70.5422 10.2666 70.7896C17.256 70.9014 27.2027 70.9174 38.7024 70.8974L37.6043 75.1022H37.609C37.3733 75.5971 37.1613 76.0959 36.9303 76.5908L39.7063 76.9021L36.9303 76.5948C35.5777 79.5442 34.2581 82.5336 32.9856 85.5069C32.552 86.5167 32.0241 87.5024 31.6706 88.5401C31.8639 88.9672 33.2353 88.6199 33.57 88.6C33.9847 87.7299 34.4324 86.8599 34.8849 86.0018L36.492 86.373C36.657 86.0896 36.9067 85.8062 37.0764 85.5069C38.6647 82.6972 40.022 79.7837 41.6056 76.966C41.9496 76.3554 42.2183 75.6968 42.6283 75.1101H42.6236L42.7791 75.1062C42.7273 75.1062 42.6802 75.1101 42.6283 75.1141C42.2183 75.7008 41.9496 76.3594 41.6056 76.97H58.161C58.6936 77.1216 62.2472 84.4413 62.8363 85.5109C62.9589 85.7304 63.1804 85.9659 63.2746 86.1295C63.5244 86.5805 64.0853 88.2887 64.4434 88.5441C64.8063 88.7996 65.7018 88.7996 66.1967 88.8554C66.9272 88.9392 67.6436 89.0989 68.3882 88.9153C68.0159 87.7459 67.4032 86.6444 66.9272 85.5109C65.6877 82.5575 64.5613 79.5363 63.2746 76.5988C63.0201 76.0201 62.6761 75.4374 62.398 74.8667C62.3933 74.8667 62.3886 74.8667 62.3839 74.8667L61.3659 70.8455C74.7837 70.7976 85.104 70.7457 89.4729 70.7936C90.5475 70.4025 90.8915 69.2411 90.425 68.379H90.4344Z"
          fill="#7F8AA5"
        />
        <Path
          d="M64.9393 84.8894C65.3892 86.1572 65.9729 87.3893 66.3235 88.697C65.6158 88.902 64.9393 88.7207 64.2466 88.6279C64.0351 87.3354 63.2615 86.0762 62.7231 84.8894C61.2666 81.6731 59.837 78.4418 58.292 75.2654L61.477 74.9191C62.6962 78.2044 63.7654 81.5836 64.9393 84.8894Z"
          fill="#CCDAFC"
        />
        <Path
          d="M36.6906 85.4429C36.2623 86.4032 35.8372 87.3753 35.4444 88.3506C35.1261 88.3701 33.826 88.7585 33.6448 88.2816C33.9803 87.1217 34.482 86.018 34.8909 84.8894C36.0972 81.562 37.3477 78.2184 38.6294 74.9191L41.2609 75.2654C39.6825 78.6316 38.2043 82.0486 36.6917 85.4429H36.6906Z"
          fill="#CCDAFC"
        />
        <Path
          d="M43.8914 73.1183L44.0295 73.2564C43.639 73.9135 43.3876 74.6482 43.0607 75.3333C41.5566 78.486 40.2738 81.7454 38.7676 84.8883C38.6079 85.2228 38.3695 85.5389 38.2141 85.8572L36.6907 85.4418C38.2033 82.0475 39.6825 78.6305 41.2599 75.2643L38.6284 74.9179C38.8615 74.317 39.0751 73.7149 39.3211 73.1183H43.8904H43.8914Z"
          fill="#91ADF9"
        />
        <Path
          d="M61.4782 74.919L58.2932 75.2654C59.8382 78.4418 61.2678 81.6731 62.7243 84.8894C62.2701 84.9995 61.5764 85.1333 61.4782 85.5821C61.3908 85.3976 61.1782 85.1376 61.0628 84.8894C60.505 83.6929 57.1377 75.5038 56.6316 75.3344L55.939 73.1183C57.4959 73.1183 59.1056 73.2327 60.6474 72.9802C60.9096 73.6211 61.2376 74.2706 61.4782 74.919Z"
          fill="#91ADF9"
        />
        <Path
          d="M62.7242 84.8894C63.2615 86.0773 64.0362 87.3354 64.2476 88.6279C63.7783 88.5653 62.9281 88.5664 62.5861 88.2816C62.2441 87.9967 61.7154 86.086 61.478 85.581C61.5762 85.1322 62.27 84.9984 62.7242 84.8884V84.8894Z"
          fill="#6378B1"
        />
        <Path
          d="M38.2144 85.8583C37.1323 88.0712 38.1896 88.1812 35.4448 88.3506C35.8376 87.3753 36.2627 86.4031 36.691 85.4429L38.2144 85.8583Z"
          fill="#6378B1"
        />
        <Path
          d="M55.9384 73.1183L56.6311 75.3344H43.0603C43.3872 74.6493 43.6386 73.9145 44.0292 73.2575C47.9867 73.0039 51.9733 73.1194 55.9384 73.1194V73.1183Z"
          fill="#003365"
        />
        <Path
          d="M60.7353 73.2499H39.2646L40.3436 70.4447H59.6564L60.7353 73.2499Z"
          fill="#6378B1"
        />
        <Path
          d="M46.855 17.11C47.1031 16.9342 52.665 16.9957 52.9477 17.11C53.0987 17.1715 53.2196 18.518 53.1559 18.6734C53.0372 18.9647 47.1128 19.064 46.855 18.8816C46.7417 18.8007 46.7417 17.191 46.855 17.11Z"
          fill="#7190E2"
        />
        <Path
          d="M84.4502 23.2028V66.2682H82.096V24.518L81.4033 23.3409C82.3819 23.3409 83.4479 23.055 84.4502 23.2028Z"
          fill="#AC70DC"
        />
        <Path
          d="M69.6346 21.9566C67.6526 21.9663 65.663 21.9501 63.68 21.9566C48.0139 22.0052 31.0219 22.6331 15.4907 21.8185C15.4907 22.3709 15.4907 22.9276 15.4907 23.48C34.2295 23.5113 52.9748 23.4736 71.7115 23.3419C74.9461 23.3193 78.1743 23.3419 81.4046 23.3419C82.3832 23.3419 83.4492 23.056 84.4515 23.2038V22.0958C79.9038 22.3688 74.3333 21.935 69.6346 21.9577V21.9566Z"
          fill="#765690"
        />
        <Path
          d="M84.4503 22.0947C79.9026 22.3677 74.3321 21.9339 69.6334 21.9566C67.6514 21.9663 65.6618 21.9501 63.6788 21.9566C46.5314 21.4106 29.248 21.9167 12.1664 21.333L12.0283 20.4331C22.18 20.4331 32.3424 20.2357 42.4929 20.1558C46.1365 20.1278 49.7887 20.1807 53.4322 20.1558C63.1652 20.0911 77.3725 21.0988 86.5272 19.8786C87.2512 19.7825 87.8306 19.762 88.4661 19.3251C89.0228 22.3299 86.5175 21.6771 84.5194 21.8174C84.405 21.825 84.4643 22.0936 84.4503 22.0947Z"
          fill="#003365"
        />
        <Path
          d="M12.0282 20.4331L12.1663 21.333C29.2479 21.9167 46.5312 21.4096 63.6787 21.9566C48.0126 22.0051 31.0206 22.6331 15.4894 21.8185C13.789 21.7289 11.8869 22.1465 11.4736 20.4342H12.0271L12.0282 20.4331Z"
          fill="#645E5F"
        />
        <Path
          d="M77.3886 67.0989L87.8434 67.3762C88.4228 67.5661 88.5253 69.136 88.1207 69.3151C72.9273 68.6343 57.7003 68.9364 42.4939 69.0378C32.1535 69.1068 21.8055 69.1047 11.4758 69.3151C11.3302 68.8166 11.1198 67.5942 11.6841 67.3762C21.3534 67.3503 31.0271 67.4108 40.6943 67.3762C52.925 67.332 65.1644 67.1292 77.3897 67.0989H77.3886Z"
          fill="url(#paint3_linear_8631_21039)"
        />
        <Path
          d="M88.466 67.7226C88.0236 66.7677 85.445 67.1281 84.4502 67.099C84.3132 67.0946 84.1719 67.1022 84.0348 67.099C81.8273 67.0472 79.5972 67.0936 77.3886 67.099L87.8434 67.3762C88.4228 67.5661 88.5253 69.136 88.1207 69.3151C72.9273 68.6343 57.7003 68.9364 42.4939 69.0378C32.1535 69.1068 21.8055 69.1047 11.4758 69.3151C11.6636 69.9581 11.793 70.1437 12.5148 70.4231C31.0109 70.7684 77.9443 70.298 87.5683 70.4231C88.589 69.9851 88.9137 68.6839 88.4681 67.7226H88.466Z"
          fill="#003365"
        />
        <Path
          d="M82.0972 66.2682C79.0071 66.2682 75.9095 66.2725 72.8195 66.2682C72.0826 66.2682 71.3403 66.2714 70.6034 66.2682C70.2355 66.266 69.8632 66.2703 69.4953 66.2682C51.4988 66.1711 33.4904 66.0556 15.4906 66.1301C15.509 66.3577 15.4173 67.1367 15.5597 67.2381L40.6922 67.3762C52.923 67.332 65.1623 67.1292 77.3877 67.099C79.5973 67.0936 81.8264 67.0472 84.035 67.099C84.172 67.1022 84.3133 67.0946 84.4503 67.099V66.2682H82.0961H82.0972Z"
          fill="url(#paint4_linear_8631_21039)"
        />
        <Path
          d="M81.4046 23.3419L82.0973 24.519V66.2692C79.0072 66.2692 75.9096 66.2736 72.8196 66.2692C72.0827 66.2692 71.3404 66.2725 70.6035 66.2692C70.2355 66.2671 69.8633 66.2714 69.4954 66.2692C51.4989 66.1721 15.4907 66.1311 15.4907 66.1311C15.4907 66.1311 15.5091 36.9386 15.4907 23.4811C34.2295 23.5124 52.9748 23.4746 71.7115 23.343C74.9461 23.3203 78.1743 23.343 81.4046 23.343V23.3419Z"
          fill="url(#paint5_linear_8631_21039)"
        />
        <Path
          d="M17.9138 25.6951L18.9528 25.9033L18.6065 64.8839L18.1221 64.6757L17.9138 25.6951Z"
          fill="#F7F1E1"
        />
        <Path
          d="M39.4471 55.467C39.2669 55.3775 38.7696 55.5447 38.5473 55.0516L21.4452 55.1897C21.1755 54.7517 20.4094 54.3795 21.0989 53.9436H38.5462C38.7739 54.9028 40.512 54.5856 39.446 55.467H39.4471Z"
          fill="#FCFCFB"
        />
        <Path
          d="M39.447 58.3758L38.5471 57.9604H21.445C21.0092 57.7242 20.7189 57.3508 20.9606 56.8524C25.7435 57.1027 30.6095 56.5438 35.3621 56.7143C36.932 56.7704 37.6495 56.6895 38.8244 57.4069C39.0003 57.5148 39.6617 57.6173 39.7242 57.7533C39.8559 58.037 39.475 58.1881 39.447 58.3769V58.3758Z"
          fill="#FCFCFB"
        />
        <Path
          d="M23.1065 59.7601C26.7026 59.6177 34.9877 59.2282 38.2007 59.7601C39.271 59.937 38.697 60.1118 38.9625 60.3136C39.0218 60.3589 39.6292 60.3794 39.7242 60.6599C39.858 61.0548 39.4674 60.9555 39.4469 61.1443L38.6852 60.8671H21.445L20.8915 60.3826C20.6973 59.4159 22.4074 59.7871 23.1076 59.759L23.1065 59.7601Z"
          fill="#FCFCFB"
        />
        <Path
          d="M39.4471 58.3758C39.4449 58.3931 39.7535 58.5107 39.7244 58.5841C39.4136 59.3426 37.7499 58.9207 37.0929 58.9304C32.652 58.993 27.6382 59.1721 23.2459 58.9304C22.4453 58.8862 20.8798 59.2595 21.4462 57.9615H38.5483L39.4482 58.3769L39.4471 58.3758Z"
          fill="#86AAA6"
        />
        <Path
          d="M35.9848 52.5593L21.4451 52.282C21.0222 52.2399 20.6909 51.3531 21.0988 51.174H35.0849C35.5284 52.2399 36.2189 51.2495 35.9848 52.5582V52.5593Z"
          fill="#FCFCFB"
        />
        <Path
          d="M39.4472 61.1454C39.4407 61.2015 40.183 61.2253 39.1009 61.8381H22.207C21.7172 61.6655 21.1097 61.5479 21.4453 60.8692H38.6855L39.4472 61.1465V61.1454Z"
          fill="#86AAA6"
        />
        <Path
          d="M39.4472 55.467C40.0891 55.7875 39.2972 55.9515 38.9627 56.1597L21.6535 56.0216C21.2694 55.8619 21.4679 55.2275 21.4453 55.1908L38.5474 55.0527C38.7696 55.5458 39.267 55.3786 39.4472 55.4681V55.467Z"
          fill="#86AAA6"
        />
        <Path
          d="M35.9848 52.5593C35.9395 52.815 36.0161 53.0999 35.3612 53.252L21.6523 53.1139L21.4441 52.2831L35.9837 52.5604L35.9848 52.5593Z"
          fill="#86AAA6"
        />
        <Path
          d="M37.0926 58.9293L36.1928 59.4828L38.2007 59.7601C34.9876 59.2282 26.7036 59.6177 23.1064 59.7601L23.2445 58.9293C27.6369 59.171 32.6517 58.9919 37.0915 58.9293H37.0926Z"
          fill="#BFDDCF"
        />
        <Path
          d="M60.9102 57.8212C70.736 64.7059 83.0249 53.8098 76.5579 43.4197C85.4622 54.168 70.9949 67.1874 60.9102 57.8212Z"
          fill="#6C7BBC"
        />
        <Path
          d="M58.5558 55.3289C58.4306 56.0831 57.9731 55.0613 57.9321 55.0516C56.8737 54.8089 54.9414 55.2318 53.7783 55.0516C53.4708 55.1887 53.6596 56.9354 53.57 57.3368C52.6486 61.4799 46.7005 62.5793 45.4004 58.2366C47.8064 62.5383 54.895 59.3048 52.9475 54.359C53.8851 54.5694 57.3172 54.0795 57.9321 54.359C58.2709 54.5132 58.3562 55.1034 58.5558 55.3278V55.3289Z"
          fill="#6894B4"
        />
        <Path
          d="M76.5579 43.4197C83.025 53.8087 70.736 64.7059 60.9102 57.8213C60.0136 56.9883 59.3565 56.2363 58.5559 55.3289C58.3574 55.1034 58.2722 54.5133 57.9323 54.36C57.3163 54.0806 53.8842 54.5704 52.9477 54.36C54.8951 59.3059 47.8066 62.5383 45.4006 58.2377C43.5837 54.9901 46.6511 51.379 50.1781 52.145C51.2958 52.3878 52.2356 53.7202 52.5323 53.8066C52.7869 53.881 57.573 53.9479 57.7252 53.7375C53.4095 41.4906 67.9545 33.0361 76.5579 43.4208V43.4197Z"
          fill="#FBE9F0"
        />
        <Path
          d="M71.6421 41.6201C73.5508 42.5328 74.8239 44.2775 75.727 46.1203L69.426 47.7128L71.6421 41.6201Z"
          fill="#4665B6"
        />
        <Path
          d="M49.4162 52.5593C49.0537 53.5562 48.5326 54.3611 48.4473 55.467C48.4106 55.9471 48.4042 55.5242 48.5854 55.8824C48.9954 56.6927 51.8406 57.4307 51.7704 58.0284C50.5394 59.6446 48.4096 60.1722 46.7157 58.9282C43.85 56.8221 45.9809 52.2432 49.4162 52.5582V52.5593Z"
          fill="#ECD2D1"
        />
        <Path
          d="M51.6324 53.9447C52.2819 54.9438 52.3801 56.2654 51.9788 57.407L48.5866 55.8835C48.4054 55.5253 48.4108 55.9482 48.4485 55.4681L51.6335 53.9447H51.6324Z"
          fill="#7F6A71"
        />
        <Path
          d="M51.6325 53.9446L48.4475 55.4681C48.5327 54.3622 49.0549 53.5573 49.4164 52.5604C50.1986 52.6327 51.2096 53.2951 51.6325 53.9446Z"
          fill="#D9B5B3"
        />
        <Path
          d="M65.6187 36.6354C71.0111 38.7479 76.1317 33.2734 72.9575 28.1885C77.6789 33.3134 71.5938 40.334 65.6187 36.6354Z"
          fill="#6C7BBC"
        />
        <Path
          d="M72.9576 28.1885C76.1318 33.2735 71.0112 38.7479 65.6187 36.6354C57.3077 31.4911 66.5574 21.2423 72.9576 28.1885Z"
          fill="#FBE9F0"
        />
        <Path
          d="M69.8632 31.3875L72.7709 32.6337C72.0071 36.4293 66.4948 37.4835 64.324 34.2262C62.2104 31.0552 64.6132 27.0319 68.2707 26.8182L68.8943 31.5957C69.1015 31.9442 69.6259 31.4943 69.8632 31.3875Z"
          fill="#809EF8"
        />
        <Path
          d="M68.9634 27.2336C69.7132 26.924 72.3879 28.564 72.2174 29.2415C72.1451 29.5275 69.7068 30.5848 69.3788 30.9721L68.9634 27.2336Z"
          fill="#645E5F"
        />
        <Path
          d="M72.3174 33.8766L69.0806 31.7727C69.4884 31.5903 72.3845 29.7896 72.5636 29.864C73.0286 30.7337 72.9617 31.6896 72.7718 32.6337L72.5871 33.3371L72.3174 33.8766Z"
          fill="#6B585B"
        />
        <Path
          d="M23.7993 44.2516C28.9318 47.0568 34.8173 41.3212 31.1382 36.3581C36.3656 41.5068 29.1465 48.0386 23.7993 44.2516Z"
          fill="#86AAA6"
        />
        <Path
          d="M31.1383 36.3581C34.8174 41.3201 28.9319 47.0557 23.7994 44.2516C17.0173 39.4482 24.8341 30.1489 31.1383 36.3581Z"
          fill="#FBE9F0"
        />
        <Path
          d="M25.3918 35.112C32.1891 33.8259 32.9788 43.3647 27.3306 44.1124C20.9488 44.9572 20.4395 36.0485 25.3918 35.112Z"
          fill="#ECD2D1"
        />
        <Path
          d="M37.6462 45.0823C46.555 51.8483 59.1784 41.8693 53.1558 31.927C60.2854 41.0029 49.3591 51.0553 39.7933 46.7439C39.2139 46.4828 37.8653 45.679 37.6473 45.0823H37.6462Z"
          fill="#6894B4"
        />
        <Path
          d="M53.1559 31.9269C59.1796 41.8682 46.5551 51.8472 37.6463 45.0823C25.7717 36.0636 42.9536 18.942 53.1559 31.9269Z"
          fill="#FBE9F0"
        />
        <Path
          d="M44.4316 31.5116C45.7749 31.6087 47.8033 32.7804 48.5855 33.8658C48.7042 34.0298 49.3785 35.3688 49.4163 35.5274C49.6321 36.438 49.6267 37.6572 49.4163 38.5743C49.2523 39.2874 48.5521 40.4074 48.032 40.9285C46.4946 42.4659 44.2623 42.8587 42.2166 42.3127C41.0406 41.9998 39.7038 41.1356 39.0316 40.0966C37.9031 38.3509 37.8728 35.7453 39.0316 34.0039C40.0793 32.4298 42.5737 31.3767 44.4316 31.5116Z"
          fill="#FBE9F0"
        />
        <Path
          d="M76.2091 47.347C75.948 47.0999 72.8871 47.9901 72.3314 48.1087C71.615 48.2609 70.9525 48.4853 70.2545 48.6622C69.5499 48.8413 68.6706 48.8769 67.9003 49.0776L70.6699 40.4235C63.6838 37.9571 57.1876 43.7337 58.4845 51.0165C58.8675 53.1711 60.4373 55.343 62.2229 56.5557C64.4552 58.0716 66.5138 58.4309 69.1464 57.9399C69.5909 57.8569 69.9491 57.8148 70.3926 57.6627C71.355 57.3325 72.3692 56.6398 73.1622 56.0011C73.6326 55.6224 74.0329 55.2286 74.4084 54.7549C74.6392 54.4636 74.7709 54.236 74.9618 53.9242C76.2609 51.8041 76.6579 49.8566 76.208 47.347H76.2091Z"
          fill="url(#paint6_radial_8631_21039)"
        />
        <Path
          d="M51.2837 32.0457C51.0247 31.6972 50.7496 31.5062 50.4529 31.2149C48.9618 29.7475 47.1956 28.7636 45.0529 28.5834C41.9218 28.3201 39.1878 29.3893 37.1594 31.7684C34.3078 35.1141 34.3413 39.5561 37.2975 42.8468C38.4541 44.134 39.3701 44.7921 41.036 45.3391C46.5893 47.1614 52.7909 43.8232 53.0833 37.723C53.12 36.9656 52.9431 36.3689 52.806 35.646C52.5331 34.2003 52.1749 33.2454 51.2826 32.0457H51.2837ZM49.484 38.4157C49.32 39.1288 48.6198 40.2487 48.0998 40.7699C46.5623 42.3073 44.33 42.7001 42.2843 42.1541C41.1083 41.8412 39.7715 40.977 39.0993 39.938C37.9708 38.1923 37.9406 35.5867 39.0993 33.8453C40.147 32.2712 42.6415 31.2181 44.4994 31.353C45.8426 31.4501 47.871 32.6218 48.6532 33.7072C48.7719 33.8712 49.4463 35.2102 49.484 35.3688C49.6998 36.2794 49.6944 37.4986 49.484 38.4157Z"
          fill="url(#paint7_radial_8631_21039)"
        />
        <Path
          d="M43.6976 40.5789C45.6463 40.5789 47.226 38.9992 47.226 37.0505C47.226 35.1018 45.6463 33.522 43.6976 33.522C41.7489 33.522 40.1692 35.1018 40.1692 37.0505C40.1692 38.9992 41.7489 40.5789 43.6976 40.5789Z"
          fill="#765690"
        />
        <Path
          d="M43.6976 33.522C41.7488 33.522 40.1692 35.1016 40.1692 37.0505C40.1692 37.7234 40.3577 38.3517 40.6841 38.8869C41.2909 39.3798 42.0644 39.6756 42.9072 39.6756C44.8561 39.6756 46.4357 38.096 46.4357 36.1472C46.4357 35.4742 46.2471 34.8459 45.9208 34.3107C45.3139 33.8179 44.5405 33.522 43.6976 33.522Z"
          fill="url(#paint8_radial_8631_21039)"
        />
        <Path
          d="M42.3144 36.7964C43.0627 36.7964 43.6693 36.1898 43.6693 35.4415C43.6693 34.6932 43.0627 34.0866 42.3144 34.0866C41.5661 34.0866 40.9595 34.6932 40.9595 35.4415C40.9595 36.1898 41.5661 36.7964 42.3144 36.7964Z"
          fill="#F5F0FF"
        />
        <Path
          d="M12.9002 18.1739H86.9956C87.8242 18.1739 88.4964 18.846 88.4964 19.6747V20.5475H11.353V19.7211C11.353 18.8676 12.0468 18.1739 12.9002 18.1739Z"
          fill="url(#paint9_linear_8631_21039)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_21039"
            x1="50"
            y1="10"
            x2="50"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_21039"
            x1="67.6758"
            y1="10.001"
            x2="67.6758"
            y2="89.089"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_21039"
            x1="50"
            y1="9.99999"
            x2="50"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_8631_21039"
            x1="49.8393"
            y1="67.0989"
            x2="49.8393"
            y2="69.3151"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#4665B6" />
            <Stop offset="1" stopColor="#7891D3" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_8631_21039"
            x1="47.0905"
            y1="66.5661"
            x2="47.0905"
            y2="67.4592"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#AC70DC" />
            <Stop offset="1" stopColor="#5C3C76" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_8631_21039"
            x1="15.5218"
            y1="44.8363"
            x2="82.0916"
            y2="44.189"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EAD8FC" />
            <Stop offset="1" stopColor="#AE89D3" />
          </LinearGradient>
          <RadialGradient
            id="paint6_radial_8631_21039"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(67.3101 49.0442) rotate(180) scale(7.39066 8.25081)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <RadialGradient
            id="paint7_radial_8631_21039"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(44.1131 37.176) rotate(-180) scale(8.41564 7.91244)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#7F9EF8" />
          </RadialGradient>
          <RadialGradient
            id="paint8_radial_8631_21039"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(42.4019 35.5315) rotate(56.3099) scale(3.22006 3.48522)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <LinearGradient
            id="paint9_linear_8631_21039"
            x1="49.9247"
            y1="18.1739"
            x2="49.9247"
            y2="20.5475"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#4665B6" />
            <Stop offset="1" stopColor="#7891D3" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstArtLessonBookingUnlocked = styled(FirstArtLessonBookingUnlockedSvg).attrs(
  ({ size, theme }) => ({
    size: size ?? theme.illustrations.sizes.medium,
  })
)``
